import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, debounce } from 'redux-saga/effects';

import { SignupApi } from '../../../infrastructure/api';
import { CompanyLookupRequest } from '../../../infrastructure/api/types/signup/CompanyLookupRequest';
import { CompanyLookupResponse } from '../../../infrastructure/api/types/signup/CompanyLookupResponse';
import { receiveCompanyLookup, REQUEST_COMPANY_LOOKUP } from '../actions';
import { GeneratorReturnType } from '../types/utility';

import { getRecaptchaToken, waitForRecaptchaReady } from './recaptcha';

export function* fetchCompanyLookup({ payload }: PayloadAction<CompanyLookupRequest>) {
  yield call(waitForRecaptchaReady);

  try {
    const recaptchaToken: GeneratorReturnType<ReturnType<typeof getRecaptchaToken>> = yield call(
      getRecaptchaToken,
      'company/lookup',
    );

    const response: CompanyLookupResponse = yield call(SignupApi.company.lookUp, payload, {
      fetchOptions: {
        ...(recaptchaToken && {
          headers: {
            'G-Recaptcha-Response': recaptchaToken,
          },
        }),
      },
    });
    yield put(receiveCompanyLookup(response.data));
  } catch {
    yield put(receiveCompanyLookup([]));
  }
}

export default function* () {
  yield debounce(500, REQUEST_COMPANY_LOOKUP, fetchCompanyLookup);
}
